<template>
    <Toast />
    <div class="p-grid">
        <div class="p-col-12">
            <div class="card p-mt-2">
                <DataTable :value="Countries" :lazy="true" :paginator="true" :rows="30" :totalRecords="totalRecords"
                    :loading="loading" @page="onPage($event)" class="p-datatable-users" dataKey="mbz1" :rowHover="true"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}">
                    <Toolbar>
                        <template v-slot:left>
                            <h5 class="p-m-0">Countries</h5>
                        </template>
                        <template v-slot:right>
                            <Button label="Add Country" icon="pi pi-plus" @click="toAddCountry" />
                            <Button label="Filter" icon="pi pi-filter" @click="filterlisting()" 
                                class="p-mr-2" style="margin-left: 0.5rem; "></Button>
                        </template>
                    </Toolbar>
                    <template #empty> No data found. </template>
                    <template #loading> Loading data. Please wait... </template>
                    <Column headerStyle="width: 2%" class="align-center"></Column>
                    <Column field="id" header="Sr." headerStyle="width: 10%">
                        <template #body="{ index }">
                            <div>{{ genrateSrNo(index) }}</div>
                        </template>
                    </Column>
                    <Column header="Country" field="maj2" class="p-text-capitalize" headerStyle="width: 25%">
                    </Column>
                    <Column header="Code" field="maj4" headerStyle="width: 20%">
                        <template #body="{ data }">
                            <div class="p-text-capitalize"> + {{ data.maj4 }}</div>
                        </template>
                    </Column>
                    <Column header="Status" headerStyle="width: 20%">
                        <template #body="{ data }">
                            <span v-if="data.maj5 == 1" :class="'user-badge status-active'">Active</span>
                            <span v-if="data.maj5 == 0" :class="'user-badge status-temp-suspend'">Inactive</span>
                        </template>
                    </Column>
                    <Column header="Action" headerStyle="width: 20%">
                        <template #body="{ data }">
                            <Button icon="pi pi-pencil" class="p-button-rounded p-button-success p-mr-2"
                                @click="editCountryModalOpen(data)" />
                            <!-- <Button icon="pi pi-trash" class="p-button-rounded p-button-danger"
                                @click="confirmDelete(data)" /> -->
                        </template>
                    </Column>
                </DataTable>
            </div>
        </div>
    </div>
    <!-- Add Role Dialog starts here -->
    <Dialog v-model:visible="isAddCountry" :style="{ width: '800px' }" :modal="true" class="p-fluid"
        header="Add Contry">
        <div style="position: relative" v-if="!showLoader">
            <div class="p-pt-2 p-px-3">
                <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-6">
                        <label for="reportreason">
                            Country
                            <span class="p-invalid p-error">*</span>
                        </label>
                        <InputText id="reportreason" v-model="reportreason" required="true" maxlength="200"
                            placeholder="Enter Country" :class="{ 'p-invalid': isSubmitted && !reportreason }" />
                        <small class="p-invalid p-error" v-if="v$.reportreason.$error">{{
                            v$.reportreason.$errors[0].$message
                        }}</small>
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label for="countrycode">Country Code <span class="p-invalid p-error">*</span></label>
                        <InputText id="countrycode" v-model="countrycode" required="true" maxlength="150"
                            :class="{ 'p-invalid': isSubmitted && !countrycode }" placeholder="Enter Country Code" />
                        <small class="p-invalid p-error" v-if="v$.countrycode.$error">{{
                            v$.countrycode.$errors[0].$message
                            }}</small>
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label for="sortname">Sort Name</label>
                        <InputText id="sortname" v-model="sortname" required="true" maxlength="100" placeholder="Enter Sort Name" />
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label>Status</label>
                        <Dropdown id="adminstatus" v-model="adminstatus" :disabled="!isEditUserRole"
                            :options="adminstatusList" optionLabel="label" placeholder="Select ..." appendTo="body">
                        </Dropdown>
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label for="countrylogo">Country Logo</label>
                        <FileUpload mode="basic" v-model="countryImage" ref="countryImage" accept="image/*"
                            :maxFileSize="1000000" chooseLabel="Upload Logo" auto @select="onSelectProfile">
                        </FileUpload>
                        <span v-if="profileUrl != ''">
                            <img class="p-pt-2" role="presentation" :alt="profileUrl.name" :src="profileUrl.url"
                                width="120" height="120" />
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <template #footer>
            <Button label="Submit" :icon="`pi ${!showLoaderAddBtn ? 'pi-check' : 'pi-spin pi-spinner indigo-color'}`"
                class="p-button-text p-ml-auto" @click="addCountry" style="width: 90px;"></Button>
        </template>
    </Dialog>
    <!-- Add Role Dialog ends here -->

    <!-- Edit Role Dialog starts here -->
    <Dialog v-model:visible="isEditUserRole" header="Edit Country" :style="{ width: '800px' }" :modal="true"
        class="p-fluid">
        <div style="position: relative" v-if="!showLoader">
            <div class="p-pt-2 p-px-3">
                <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-6">
                        <label for="reportreason">
                            Country
                            <span class="p-invalid p-error">*</span>
                        </label>
                        <InputText id="reportreason" v-model.trim="reportreason" required="true" maxlength="200"
                            autofocus :class="{ 'p-invalid': isSubmitted && !reportreason }" />
                        <small class="p-invalid p-error" v-if="v$.reportreason.$error">{{
                            v$.reportreason.$errors[0].$message
                        }}</small>
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label for="countrycode">Country Code <span class="p-invalid p-error">*</span></label>
                        <InputText id="countrycode" v-model="countrycode" required="true" maxlength="150"
                            :class="{ 'p-invalid': isSubmitted && !countrycode }" />
                        <small class="p-invalid p-error" v-if="v$.countrycode.$error">{{
                            v$.countrycode.$errors[0].$message
                            }}</small>
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label for="sortname">Sort Name</label>
                        <InputText id="sortname" v-model="sortname" required="true" maxlength="100" />
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label>Status</label>
                        <Dropdown id="adminstatus" v-model="adminstatus" :options="adminstatusList" optionLabel="label"
                            placeholder="Select ..." appendTo="body">
                        </Dropdown>
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label for="countrylogo">Country Logo</label>
                        <FileUpload mode="basic" v-model="countryImage" ref="countryImage" accept="image/*"
                            :maxFileSize="1000000" chooseLabel="Upload Logo" auto @select="onSelectProfile">
                        </FileUpload>
                        <span v-if="profileImage == '' && profileImageFlag != null && profileUrl != ''">
                            <img class="p-pt-2" role="presentation" :alt="profileUrl"
                                :src="getStoragePath + this.master_bucket_name + '/Flags/' + profileUrl"
                                width="120" height="120" />
                        </span>
                        <span v-else-if="profileImage != '' && profileImageFlag != null && profileUrl != ''">
                            <img class="p-pt-2" role="presentation" :alt="profileUrl.name" :src="profileUrl.url"
                                width="120" height="120" />
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <template #footer>
            <Button label="Submit" :icon="`pi ${!showLoaderAddBtn ? 'pi-check' : 'pi-spin pi-spinner indigo-color'}`"
                class="p-button-text p-ml-auto" @click="editCountry(rowData)" style="width: 90px;"></Button>
        </template>
    </Dialog>
    <!-- Edit Role Dialog ends here -->

    <!-- Filter dialog start here -->
    <Dialog v-model:visible="isFilter" :style="{ width: '600px' }" header="Country Filter" :modal="true"
        class="p-fluid">
        <div class="p-pt-2 p-px-3">
            <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col-12 p-md-6">
                    <label for="countryfilter"> Country <span class="p-invalid p-error">*</span></label>
                    <Dropdown id="countryfilter" v-model="countryFilter" :options="countriesFilterList" optionLabel="label"
                    placeholder="Select ..." appendTo="body" :filter="true"></Dropdown>
                </div>
                <div class="p-field p-col-12 p-md-6">
                    <label>Status</label>
                    <Dropdown id="adminstatus" v-model="adminstatus" :options="adminstatusList" optionLabel="label"
                        placeholder="Select ..." appendTo="body">
                    </Dropdown>
                </div>
            </div>
        </div>
        <template #footer>
            <Button label="Reset" icon="pi pi-refresh" class="p-button-text" @click="reSetFilteredData()" />
            <Button label="Search" icon="pi pi-search" class="p-mr-2" autofocus @click="submitFilter" />
        </template>
    </Dialog>
    <!-- Filter dialog end here -->
</template>

<script>
import ApiService from '../../service/ApiService';
import useValidate from '@vuelidate/core';
import { useConfirm } from "primevue/useconfirm";
import { required, helpers } from '@vuelidate/validators';

export default {
    data() {
        return {
            confirm: useConfirm(),
            Countries: [],
            v$: useValidate(),
            isAddCountry: false,
            isSubmitted: false,
            showLoader: false,
            loading: false,
            page_no: 0,
            totalRecords: 0,
            isEditUserRole: false,
            showLoaderAddBtn: false,
            rowId: '',
            reportreason: '',
            sortname: '',
            countrycode: '',
            countryImage: '',
            profileUrl: '',
            profileImage: '',
            profileImageFlag: '',
            adminstatus: { label: 'Active', value: 1 },
            adminstatusList: [
                { label: 'Active', value: 1 },
                { label: 'Inactive', value: 0 },
            ],
            isFilter: false,
            countryFilter: '',
            countriesFilterList : [],
        };
    },
    validations() {
        return {
            reportreason: { required: helpers.withMessage('Please enter Country', required) },
            adminstatus: { required: helpers.withMessage('Please select admin status', required) },
            countrycode: { required: helpers.withMessage('Please enter country code', required) },
        };
    },
    ApiService: null,
    created() {
        this.ApiService = new ApiService();
    },
    async mounted() {
        this.client_info = JSON.parse(localStorage.getItem('masterBucketName'));
        this.master_bucket_name = this.client_info;
        this.getStoragePath = JSON.parse(localStorage.getItem('storagePath'));
        this.loading = true;
        this.getAllCountries({ page_no: this.page_no });
    },
    methods: {
        getAllCountries(e) {
            e.page_no = this.page_no;
            this.ApiService.getAllCountries(e).then((items) => {
                if (items.status === 200) {
                    this.Countries = items.data;
                    this.totalRecords = items.count;
                    this.isFilter = false;
                } else {
                    this.Countries = [];
                }
                this.loading = false;
            });
        },
        async toAddCountry() {
            this.isAddCountry = true;
            this.isSubmitted = false;
            this.profileUrl = '';
            this.reportreason = '';
            this.countrycode = '';
            this.countryImage = '';
            this.sortname = '';
            this.profileImage = '';
            this.adminstatus = { label: 'Active', value: 1 };
            this.v$.$reset();
        },
        addCountry() {
            this.submitted = true;
            this.errormsg = '';
            this.v$.$validate();
            let formData = new FormData();
            formData.append('maj2', this.reportreason);
            formData.append('maj3', this.sortname);
            formData.append('maj4', this.countrycode);
            formData.append('maj5', this.adminstatus.value);
            if (this.profileImage) {
                formData.append('countryLogo', this.profileImage);
            }

            this.v$.$validate();
            if (!this.v$.$error) {
                this.showLoaderAddBtn = true;
                this.ApiService.insertOrUpdateCountries(formData).then((items) => {
                    if (items.status == 200) {
                        this.showLoaderAddBtn = false;
                        var successMsg = items.message;
                        this.$toast.add({ severity: 'success', summary: 'Successful', detail: successMsg, life: 3000 });
                        this.getAllCountries({ page_no: this.page_no });
                        this.isAddCountry = false;
                        this.reportreason = '';
                    } else {
                        this.showLoaderAddBtn = false;
                        var errorMsg = items.message;
                        this.$toast.add({ severity: 'error', summary: 'Error', detail: errorMsg, life: 3000 });
                    }
                });
            }
        },
        editCountryModalOpen(data) {
            this.profileImage = '';
            this.profileUrl = '';
            this.isEditUserRole = true;
            this.reportreason = '';
            this.adminstatus = '';
            this.rowId = data.maj1;
            this.reportreason = data.maj2;
            this.sortname = data.maj3;
            this.countrycode = data.maj4;
            this.profileUrl = data.maj6;
            this.profileImageFlag = data.maj7;
            this.countryImage = "";
            this.adminstatus = this.adminstatusList.find((item) => item.value == data.maj5);
        },
        editCountry() {
            this.submitted = true;
            this.errormsg = '';
            let formData = new FormData();
            formData.append('maj1', this.rowId);
            formData.append('maj2', this.reportreason);
            formData.append('maj3', this.sortname);
            formData.append('maj4', this.countrycode);
            formData.append('maj5', this.adminstatus.value);
            if (this.countryImage != '') {
                formData.append('countryLogo', this.countryImage);
            }


            this.v$.$validate();
            if (!this.v$.$error) {
                this.showLoaderAddBtn = true;
                this.ApiService.insertOrUpdateCountries(formData).then((items) => {
                    if (items.status == 200) {
                        this.showLoaderAddBtn = false;
                        var successMsg = items.message;
                        this.$toast.add({ severity: 'success', summary: 'Successful', detail: successMsg, life: 3000 });
                        this.getAllCountries({ page_no: this.page_no });
                        this.isEditUserRole = false;
                        this.reportreason = '';
                    } else {
                        this.showLoaderAddBtn = false;
                        var errorMsg = items.message;
                        this.$toast.add({ severity: 'error', summary: 'Error', detail: errorMsg, life: 3000 });
                    }
                });
            }
        },
        async deleteCountry(data) {
            let formData = new FormData();
            formData.append('map1', data.map1);
            this.showLoaderAddBtn = true;
            try {
                const response = await this.ApiService.removeIPCSection(formData);
                if (response.status === 200) {
                    this.$toast.add({ severity: 'success', summary: 'Deleted', detail: response.message, life: 3000 });
                    this.getAllCountries({ page_no: this.page_no });
                } else {
                    this.$toast.add({ severity: 'error', summary: 'Error', detail: response.message, life: 3000 });
                }
            } catch (error) {
                console.error("Error deleting record:", error);
                this.$toast.add({ severity: 'error', summary: 'Error', detail: 'Failed to delete', life: 3000 });
            } finally {
                this.showLoaderAddBtn = false;
            }
        },
        confirmDelete(data) {
            this.$confirm.require({
                group: 'positioned',
                message: 'Are you sure you want to delete this record?',
                header: 'Confirm Deletion',
                icon: 'pi pi-exclamation-triangle',
                position: 'top',
                rejectProps: {
                    label: 'Cancel',
                    severity: 'secondary',
                    outlined: true
                },
                acceptProps: {
                    label: 'Delete',
                    severity: 'danger'
                },
                accept: () => {
                    this.deleteCountry(data);
                },
                reject: () => {
                    this.$toast.add({ severity: 'error', summary: 'Cancelled', detail: 'Deletion cancelled', life: 3000 });
                }
            });
        },
        onPage(event) {
            this.loading = true;
            this.page_no = event.page;
            this.getAllCountries({ page_no: event.page });
        },
        async onSelectProfile(e) {
            this.profileImage = e.files[0];
            const file = e.files[0];
            let allowedExtensions = /(\.jpg|\.jpeg|\.png)$/i;
            if (!file.size > 2048) {
                this.profileImageError = 'File size cannot exceed more than 2MB';
                this.profileImage = '';
            } else if (!file.name.match(allowedExtensions)) {
                this.profileImageError = 'Invalid file type';
                this.profileImage = '';
            } else {
                this.profileImageError = '';
                if (file && file.type.includes('image/')) {
                    this.profileUrl = { url: file.objectURL, name: file.name };
                    this.profileImage = e.files[0];
                    this.countryImage = e.files[0];
                    // this.profileImageFlag = null;
                } else {
                    this.profileImageError = 'Invalid file type';
                    this.profileImage = '';
                }
            }
        },
        getCountries() {
            this.ApiService.getCountries().then((items) => {
                if (items.status === 200) {
                    this.countriesFilterList = items.data;
                }
            })
        },
        reSetFilteredData() {
            this.getAllCountries({ page_no: this.page_no });
            this.isFilter = false;
            this.countryFilter = '';
            this.adminstatus = { label: 'Active', value: 1 };
            // this.showFillFilter = false;
        },
        filterlisting() {
            this.isFilter = true;
            this.adminstatus = { label: 'Active', value: 1 };
            this.getCountries();
        },
        submitFilter() {
            this.showFillFilter = true;
            this.getAllCountries({ maj2: this.countryFilter.label, maj5: this.adminstatus.value, page_no: this.page_no });
        },
    }
};
</script>